module.exports = __webpack_public_path__ + "img/JR.6f3f2491.png";